import React, { useState } from "react";
import { Button, Table, Tbody, Td, Th, Thead, Tr } from "@chakra-ui/react";
import { addDealer, deleteDealer } from "../../services/dealerApi";
import Loader from "../../UI/Loader";
import InputField from "../../UI/InputField";
import Gap from "../../UI/Gap";
import { toast } from "sonner";
import { getErrorMessage, getSuccessMessage } from "../../functions";
import { useDispatch, useSelector } from "react-redux";
import { updateDealer, removeDealer } from "../../redux/dealerSlice";
import { MdCancel } from "react-icons/md";
import { FaTrashAlt, FaEdit } from "react-icons/fa";
import { itemsPerPage } from "../../constant";
import ListPagination from "../../UI/ListPagination";


const Dealers = () => {
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();
  const [isEdit, setIsEdit] = useState(false);
  const [dealerDetails, setDealerDetails] = useState({
    name: "",
    address: "",
    phoneNumber: "",
    gst: "",
    email: "",
    whatsappNumber: "",
  });
  const dealers = useSelector((state) => state.dealer.dealers);
  const isMobileView = useSelector((state) => state.mobileView.isMobileView);

  const [currentPage, setCurrentPage] = useState(0);
  const [searchTerm, setSearchTerm] = useState("");

  const filteredProducts = dealers.filter(
    (product) =>
      (product.name &&
        product.name.toLowerCase().includes(searchTerm.toLowerCase())) ||
      (product.address &&
        product.address.toLowerCase().includes(searchTerm.toLowerCase())) ||
      (product.phoneNumber &&
        product.phoneNumber.toLowerCase().includes(searchTerm.toLowerCase())) ||
      (product.email &&
        product.email.toLowerCase().includes(searchTerm.toLowerCase())) ||
      (product.gst &&
        product.gst.toLowerCase().includes(searchTerm.toLowerCase())) ||
      (product.whatsappNumber &&
        product.whatsappNumber.toLowerCase().includes(searchTerm.toLowerCase()))
  );

  const pageCount = Math.ceil(filteredProducts.length / itemsPerPage);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setDealerDetails({
      ...dealerDetails,
      [name]: value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const res = await addDealer({ ...dealerDetails, isEdit });
      dispatch(updateDealer(res.data));
      setDealerDetails({
        name: "",
        address: "",
        phoneNumber: "",
        gst: "",
        email: "",
        whatsappNumber: "",
      });
      setIsEdit(false);
      toast.success(getSuccessMessage(res));
    } catch (error) {
      toast.error(getErrorMessage(error));
    }
    setLoading(false);
  };

  const handleEdit = (dealer) => {
    setDealerDetails(dealer);
    setIsEdit(true);
  };

  const handleDeleteDealer = async (dealer) => {
    try {
      setLoading(true);
      const confirmed = window.confirm(
        "Are you sure you want to delete this dealer?"
      );
      if (confirmed) {
        await deleteDealer(dealer._id);
        dispatch(removeDealer(dealer._id));
      }
    } catch (error) {
      toast.error(getErrorMessage(error));
    } finally {
      setLoading(false);
    }
  };

  const handlePageClick = (data) => {
    const selectedPage = data.selected;
    setCurrentPage(selectedPage);
  };
  const offset = currentPage * itemsPerPage;
  const endOffset = offset + itemsPerPage;

  const currentProducts = filteredProducts.slice(
    offset,
    Math.min(endOffset, filteredProducts.length)
  );

  if (loading) return <Loader />;

  return (
    <div>
      <Gap>Enter Dealer Details</Gap>
      <form
        className="flex lg:flex-wrap lg:flex-row gap-4 flex-col"
        onSubmit={handleSubmit}
      >
        <InputField
          labelName="Name"
          type="text"
          required
          uni="name"
          value={dealerDetails.name}
          onChange={handleChange}
        />
        <InputField
          labelName="Address"
          type="text"
          required
          uni="address"
          value={dealerDetails.address}
          onChange={handleChange}
        />
        <InputField
          labelName="Phone No"
          type="tel"
          required
          uni="phoneNumber"
          value={dealerDetails.phoneNumber}
          onChange={handleChange}
        />
        <InputField
          labelName="GST"
          type="text"
          uni="gst"
          required
          value={dealerDetails.gst}
          onChange={handleChange}
        />
        <InputField
          labelName="Email"
          type="email"
          uni="email"
          value={dealerDetails.email}
          onChange={handleChange}
        />
        <InputField
          labelName="Whatsapp No"
          type="tel"
          uni="whatsappNumber"
          value={dealerDetails.whatsappNumber}
          onChange={handleChange}
        />
        <Button
          type="submit"
          variant="solid"
          colorScheme="blue"
          size="md"
          className="mt-6"
        >
          Add
        </Button>
      </form>
      <Gap>Dealers</Gap>
      <InputField
        type="text"
        placeholder="Search dealers..."
        value={searchTerm}
        onChange={(e) => setSearchTerm(e.target.value)}
        className="border-2 border-gray-300 bg-white h-10 px-5 pr-16  text-sm focus:outline-none"
      />
      <div className="overflow-y-auto">
        {isMobileView ? (
          <div className="flex flex-col gap-4 p-4">
            {currentProducts.map((customer, index) => (
              <div key={index} className="bg-gray-100 p-2  shadow-md">
                <div className="font-bold">{customer.name}</div>
                <div className="flex flex-col gap-1">
                  <div>
                    <span className="font-semibold">Address:</span>{" "}
                    {customer.address}
                  </div>
                  <div>
                    <span className="font-semibold">Phone Number:</span>{" "}
                    {customer.phoneNumber}
                  </div>
                  <div>
                    <span className="font-semibold">GST:</span> {customer.gst}
                  </div>
                  <div>
                    <span className="font-semibold">Email:</span>{" "}
                    {customer.email}
                  </div>
                  <div>
                    <span className="font-semibold">Whatsapp No:</span>{" "}
                    {customer.whatsappNumber}
                  </div>
                  <div className="flex gap-2 mt-2">
                    {isEdit ? (
                      <Button
                        onClick={() => {
                          setIsEdit(false);
                          setDealerDetails({
                            name: "",
                            address: "",
                            phoneNumber: "",
                            gst: "",
                            email: "",
                            whatsappNumber: "",
                          });
                        }}
                      >
                        <MdCancel size={20} color="blue" />
                      </Button>
                    ) : (
                      <>
                        <Button onClick={() => handleEdit(customer)} size="xs">
                          <FaEdit size={20} color="blue" />
                        </Button>
                        <Button
                          onClick={() => handleDeleteDealer(customer)}
                          size="xs"
                        >
                          <FaTrashAlt size={20} color="red" />
                        </Button>
                      </>
                    )}
                  </div>
                </div>
              </div>
            ))}
          </div>
        ) : (
          <Table variant="striped" className="mt-4">
            <Thead>
              <Tr>
                <Th>Name</Th>
                <Th>Address</Th>
                <Th>Phone Number</Th>
                <Th>GST</Th>
                <Th>Email</Th>
                <Th>Whatsapp No</Th>
                <Th>Action</Th>
              </Tr>
            </Thead>
            <Tbody>
              {currentProducts.map((customer, index) => (
                <Tr key={index}>
                  <Td>{customer.name}</Td>
                  <Td>{customer.address}</Td>
                  <Td>{customer.phoneNumber}</Td>
                  <Td>{customer.gst}</Td>
                  <Td>{customer.email}</Td>
                  <Td>{customer.whatsappNumber}</Td>
                  <Td className="flex">
                    {isEdit ? (
                      <Button
                        onClick={() => {
                          setIsEdit(false);
                          setDealerDetails({
                            name: "",
                            address: "",
                            phoneNumber: "",
                            gst: "",
                            email: "",
                            whatsappNumber: "",
                          });
                        }}
                      >
                        <MdCancel size={24} color="blue" />
                      </Button>
                    ) : (
                      <>
                        <Button onClick={() => handleEdit(customer)}>
                          <FaEdit size={24} color="blue" />
                        </Button>
                        <Button onClick={() => handleDeleteDealer(customer)}>
                          <FaTrashAlt size={24} color="red" />
                        </Button>
                      </>
                    )}
                  </Td>
                </Tr>
              ))}
            </Tbody>
          </Table>
        )}
      </div>

      <ListPagination
        pageCount={pageCount}
        onPageChange={handlePageClick}
        isMobileView={isMobileView}
      />
    </div>
  );
};
export default Dealers;
